<script>
import Detail from '@components/details'
import Approval from '@components/approval'
import Update from '@components/updatereport'
import Upload from '@components/uploadreport'
import downloadButton from '@components/downloadButton'
import TableDetail from '@components/table-detail'
import { authComputed, siteListComputed } from '@state/helpers'
import { ADMIN_ROLE, TEACHER_ROLE, COLLEGE_ROLE } from '@utils/constant'
import { mergeArray } from '@utils/common'
import formatDate from '@utils/format-date'
import formatTime from '@utils/format-time'
import tConvert from '@utils/format-hour'
import BatchUpdate from '@components/batchUpdate'
import AssignedUser from '@components/assignedUsers'
import TeacherDataUpdate from '@components/teacherDataUpdate'
import AssignmentUpdate from '@components/assignmentUpdate'
// import CourseEventUpdate from '@components/courseEventUpdate'
// import CourseEventDelete from '@components/courseEventDelete'
import TrainingEventUpdate from '@components/trainingEventUpdate'
import TrainingEventDelete from '@components/trainingEventDelete'
import ResourceUpdate from '@components/resourceUpdate'
import ResourceDelete from '@components/resourceDelete'
import AssignmentDelete from '@components/assignmentDelete'
import MeetingUpdate from '@components/meetingUpdate'
import MeetingDelete from '@components/meetingDelete'
import EventUpdate from '@components/eventDataUpdate'
import EventDelete from '@components/eventDataDelete'
import BlogUpdate from '@components/blogDataUpdate'
import BlogDelete from '@components/blogDataDelete'
import moment from 'moment'
export default {
  components: {
    Detail: Detail,
    TableDetail: TableDetail,
    Update: Update,
    Upload: Upload,
    DownloadButton: downloadButton,
    Approval: Approval,
    BatchUpdate: BatchUpdate,
    AssignedUser: AssignedUser,
    TeacherDataUpdate: TeacherDataUpdate,
    AssignmentUpdate: AssignmentUpdate,
    // CourseEventUpdate: CourseEventUpdate,
    // CourseEventDelete: CourseEventDelete,
    TrainingEventUpdate: TrainingEventUpdate,
    TrainingEventDelete: TrainingEventDelete,
    ResourceUpdate: ResourceUpdate,
    ResourceDelete: ResourceDelete,
    AssignmentDelete: AssignmentDelete,
    MeetingUpdate: MeetingUpdate,
    MeetingDelete: MeetingDelete,
    EventUpdate: EventUpdate,
    EventDelete: EventDelete,
    BlogUpdate: BlogUpdate,
    BlogDelete: BlogDelete,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    fields: {
      type: Array,
      required: true,
      default: () => [],
    },
    tableName: {
      type: String,
      default: '',
    },
    pagingCounter: {
      type: Number,
      required: true,
      default: 1,
    },
    totalPage: {
      type: Number,
      required: true,
      default: 1,
    },
    displayFields: {
      type: Array,
      required: true,
      default: () => [],
    },
    htmlFields: {
      type: Array,
      default: () => [],
    },
    striped: {
      type: Boolean,
      required: false,
      default: false,
    },
    bordered: {
      type: Boolean,
      required: false,
    },
    viewbtn: {
      type: Boolean,
      default: false,
    },
    joinbtn: {
      type: Boolean,
      default: false,
    },
    deletebtn: {
      type: Boolean,
      default: false,
    },
    editbtn: {
      type: Boolean,
      default: false,
    },
    teacher: {
      type: Boolean,
      default: false,
    },
    assignment: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: Boolean,
      default: false,
    },
    courseEvent: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Boolean,
      default: false,
    },
    blog: {
      type: Boolean,
      default: false,
    },
    trainingEvent: {
      type: Boolean,
      default: false,
    },
    liveclass: {
      type: Boolean,
      default: false,
    },
    editdomain: {
      type: Boolean,
      default: false,
    },
    addbtn: {
      type: Boolean,
      default: false,
    },
    downloadbtn: {
      type: Boolean,
      default: false,
    },
    updatebtn: {
      type: Boolean,
      default: false,
    },
    uploadbtn: {
      type: Boolean,
      default: false,
    },
    actionBtn: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      required: true,
      default: 1,
    },
    totalRows: {
      type: Number,
      required: true,
      default: 1,
    },
    perPage: {
      type: Number,
      required: true,
      default: 10,
    },
    size: {
      type: String,
      default: 'xl',
    },
  },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      TEACHER_ROLE: TEACHER_ROLE,
      COLLEGE_ROLE: COLLEGE_ROLE,
      active: 0,
      update: 0,
      upload: 0,
      details: [],
      reportData: [],
      Report: [],
      searchInput: [],
      filterItems: [],
      isSearch: false,
      previousRow: '',
      approvalDetails: [],
      approveActive: 0,
      batchEdit: 0,
      batchData: [],
      showUsers: 0,
      usersData: [],
      teacherEdit: 0,
      teacherData: [],
      assignmentEdit: 0,
      assignmentData: [],
      courseEventEdit: 0,
      courseEventData: [],
      trainingEventEdit: 0,
      trainingEventData: [],
      deleteEvent: false,
      deleteData: [],
      deleteTrainingEvent: false,
      deleteTrainingData: [],
      resourceEdit: 0,
      resourceData: [],
      deleteResource: false,
      deleteResourceData: [],
      deleteAssignment: false,
      deleteAssignmentData: [],
      meetingEdit: 0,
      meetingEditData: [],
      meetingDelete: 0,
      meetingDeleteData: [],
      eventUpdate: 0,
      eventUpdateData: [],
      eventDelete: 0,
      eventDeleteData: [],
      blogUpdate: 0,
      blogUpdateData: [],
      blogDelete: 0,
      blogDeleteData: [],
    }
  },
  computed: {
    ...authComputed,
    ...siteListComputed,
  },
  methods: {
    getAssignmentEdit(data) {
      this.assignmentEdit = 1
      this.assignmentData = data
    },
    getResourceEdit(data) {
      this.resourceEdit = 1
      this.resourceData = data
    },
    getCourseEventEdit(data) {
      this.courseEventEdit = 1
      this.courseEventData = data
    },
    getMeetingEdit(data) {
      this.meetingEdit = 1
      this.meetingEditData = data
    },
    getMeetingDelete(data) {
      this.meetingDelete = 1
      this.meetingDeleteData = data
    },
    getDomainEdit(data) {
      this.domainEdit = 1
      this.domainEditData = data
    },
    getDomainDelete(data) {
      this.domainDelete = 1
      this.domainDeleteData = data
    },
    getEventEdit(data) {
      this.eventUpdate = 1
      this.eventUpdateData = data
    },
    getEventDelete(data) {
      this.eventDelete = 1
      this.eventDeleteData = data
    },
    getBlogEdit(data) {
      this.blogUpdate = 1
      this.blogUpdateData = data
    },
    getBlogDelete(data) {
      this.blogDelete = 1
      this.blogDeleteData = data
    },
    getTrainingEventEdit(data) {
      this.trainingEventEdit = 1
      this.trainingEventData = data
    },
    getBatchEdit(data) {
      this.batchEdit = 1
      this.batchData = data
    },
    getTeacherEdit(data) {
      this.teacherEdit = 1
      this.teacherData = data
    },
    getdata(data) {
      if (data.deadline) {
        this.$router.push({
          path: `/assignment-list/${data._id}`,
        })
      } else {
        this.active = 1
        this.details = data
      }
    },
    approvaldata(data) {
      this.approveActive = 1
      this.approvalDetails = data
    },
    updateReport(data) {
      this.update = 1
      this.reportData = data
    },
    uploadReport(data) {
      this.upload = 1
      this.Report = data
    },
    formatDates(date) {
      return formatDate(date)
    },
    getEventTime(time) {
      return tConvert(formatTime(moment(time).format('HH:mm')))
    },
    getMeetingTime(time) {
      return tConvert(formatTime(time))
    },
    getboxtype(key) {
      if (key === 'phone') {
        return 'number'
      } else {
        return 'text'
      }
    },
    onTextChange() {
      this.filterItems = []
      var searchStatus = false

      for (var key in this.searchInput) {
        if (
          this.searchInput[key] &&
          this.searchInput[key] !== null &&
          this.searchInput[key].length > 0 &&
          this.searchInput[key] !== '' &&
          this.searchInput[key] !== ' '
        ) {
          searchStatus = true
        }

        var filterItem = []

        if (key === 'collegeId') {
          filterItem = this.items.filter((item) => {
            var filterItem1 = item.college.filter((item1) => {
              return (
                item1['site_name']
                  .toLowerCase()
                  .indexOf(this.searchInput[key].toLowerCase()) > -1
              )
            })
            if (filterItem1.length > 0) {
              return true
            } else {
              return false
            }
          })
        } else if (key === 'tags') {
          filterItem = this.items.filter((item) => {
            var filterItem1 = item.tags.filter((item1) => {
              return (
                item1
                  .toLowerCase()
                  .indexOf(this.searchInput[key].toLowerCase()) > -1
              )
            })
            if (filterItem1.length > 0) {
              return true
            } else {
              return false
            }
          })
        } else if (key === 'categoryName' || key === 'category.name') {
          filterItem = this.items.filter((item) => {
            return (
              item.category.name
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'phone') {
          filterItem = this.items.filter((item) => {
            return item.phone.toString().indexOf(this.searchInput[key]) > -1
          })
        } else if (key === 'subcategoryName' || key === 'subcategory.name') {
          filterItem = this.items.filter((item) => {
            return (
              item.subcategory.name
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'date') {
          filterItem = this.items.filter((item) => {
            return (
              this.formatDates(item.date)
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'deadline') {
          filterItem = this.items.filter((item) => {
            return (
              this.formatDates(item.deadline)
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'start') {
          filterItem = this.items.filter((item) => {
            return (
              this.formatDates(item.start)
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'end') {
          filterItem = this.items.filter((item) => {
            return (
              this.formatDates(item.end)
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'time') {
          filterItem = this.items.filter((item) => {
            return (
              this.getMeetingTime(item.time)
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'eventtime') {
          filterItem = this.items.filter((item) => {
            return (
              this.getEventTime(item.time)
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        } else if (key === 'status') {
          // eslint-disable-next-line no-unneeded-ternary
          var status =
            this.searchInput[key].toLowerCase() === 'pending' ||
            this.searchInput[key].toLowerCase() === 'done'
              ? this.searchInput[key].toLowerCase() === 'pending'
                ? // eslint-disable-next-line no-unneeded-ternary
                  false
                : true
              : ''
          if (status !== '') {
            filterItem = this.items.filter((item) => {
              return item.status === status
            })
          }
        } else if (key === 'rating') {
          filterItem = this.items.filter((item) => {
            return item.rating.toString().indexOf(this.searchInput[key]) > -1
          })
        } else if (key === 'loginStatus') {
          status =
            this.searchInput[key].toLowerCase() === 'inactive' ||
            this.searchInput[key].toLowerCase() === 'active'
              ? this.searchInput[key].toLowerCase() === 'inactive'
                ? // eslint-disable-next-line no-unneeded-ternary
                  false
                : true
              : ''
          if (status !== '') {
            filterItem = this.items.filter((item) => {
              return item.loginStatus === status
            })
          }
        } else {
          filterItem = this.items.filter((item) => {
            return (
              item[key]
                .toLowerCase()
                .indexOf(this.searchInput[key].toLowerCase()) > -1
            )
          })
        }

        if (filterItem.length > 0) {
          this.filterItems = mergeArray(this.filterItems, filterItem)
        }
      }

      this.isSearch = searchStatus

      if (!this.isSearch) {
        this.resetFilter()
      }
    },
    resetFilter() {
      this.searchInput = []
      this.filterItems = []
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
    redirectMeeting(data1) {
      this.$router.push({
        path: `/meeting-start/${data1.meeting_id}/${data1.meta.password}`,
      })

      // window.open(routeData.href, '_blank')
    },
    expandTable(row) {
      row.toggleDetails()
    },
    showAssignedUsers(data) {
      this.showUsers = 1
      this.usersData = data
    },
    getCourseEventDelete(data) {
      this.deleteEvent = true
      this.deleteData = data
    },
    getTrainingEventDelete(data) {
      this.deleteTrainingEvent = true
      this.deleteTrainingData = data
    },
    getResourceDelete(data) {
      this.deleteResource = true
      this.deleteResourceData = data
    },
    getAssignmentDelete(data) {
      this.deleteAssignment = true
      this.deleteAssignmentData = data
    },
  },
}
</script>

<template>
  <div>
    <b-table
      id="datatable"
      :fields="fields"
      :items="isSearch ? filterItems : items"
      :bordered="bordered"
      :striped="striped"
      :display-fields="displayFields"
      :html-fields="htmlFields"
      responsive="md"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template v-slot:head()="scope">
        <div class="text-nowrap capital">{{ scope.field.label }}</div>
        <div
          v-if="
            scope.field.label !== 'Action' && scope.column !== 'detailAction'
          "
          class="form-group"
        >
          <input
            :id="scope.column"
            v-model="searchInput[scope.column]"
            :type="getboxtype(scope.column)"
            class="form-control"
            :name="scope.column"
            :placeholder="'Search...'"
            @keyup="onTextChange"
          />
        </div>
        <div v-else><br /></div>
      </template>
      <template v-slot:cell(status)="data">
        <b-badge v-if="data.item.status" variant="success">Done</b-badge>
        <b-badge v-else variant="danger">Pending</b-badge>
      </template>
      <template v-slot:cell(eventstatus)="data">
        <b-badge v-if="data.item.status === 'true'" variant="success"
          >Yes</b-badge
        >
        <b-badge v-else variant="danger">No</b-badge>
      </template>
      <template v-slot:cell(loginStatus)="data">
        <b-badge v-if="data.item.loginStatus" variant="success">Active</b-badge>
        <b-badge v-else variant="danger">Inactive</b-badge>
      </template>
      <template v-slot:cell(date)="data">{{
        formatDates(data.item.date)
      }}</template>
      <template v-slot:cell(deadline)="data">{{
        formatDates(data.item.deadline)
      }}</template>
      <template v-slot:cell(start)="data">{{
        formatDates(data.item.start)
      }}</template>
      <template v-slot:cell(end)="data">{{
        formatDates(data.item.end)
      }}</template>
      <template v-slot:cell(time)="data">{{
        getMeetingTime(data.item.time)
      }}</template>
      <template v-slot:cell(eventtime)="data">{{
        getEventTime(data.item.time)
      }}</template>

      <template v-slot:cell(tags)="data">
        <div v-for="(item1, index1) in data.item.tags" :key="`list${index1}`">
          <p v-if="index1 + 1 === data.item.tags.length">{{ item1 }}</p>
          <p v-else>{{ item1 }},</p>
        </div>
      </template>
      <template v-slot:cell(assigned_to)="data">
        <b-button
          v-b-modal="'users-modal'"
          size="sm"
          class="mr-2"
          variant="link"
          @click="showAssignedUsers(data)"
          >Assigned Students List</b-button
        >
      </template>
      <template v-slot:cell(assigned_to_resource)="data">
        <div
          v-for="(item1, index1) in data.item.assigned_to"
          :key="`list${index1}`"
        >
          <div v-if="item1.name !== undefined">
            <p v-if="index1 + 1 === data.item.assigned_to.length">{{
              item1.name
            }}</p>
            <p v-else>{{ item1.name }},</p>
          </div>
          <div v-else>
            <p v-if="index1 + 1 === data.item.assigned_to.length">{{
              item1
            }}</p>
            <p v-else>{{ item1 }},</p>
          </div>
        </div>
      </template>
      <template v-slot:cell(document)="data">
        <div
          v-for="(item1, index1) in data.item.document"
          :key="`list${index1}`"
        >
          <p v-if="index1 + 1 === data.item.document.length">{{ item1 }}</p>
          <p v-else>{{ item1 }},</p>
        </div>
      </template>
      <template v-slot:cell(course_id)="data">
        <div
          v-for="(item1, index1) in data.item.course_id"
          :key="`list${index1}`"
        >
          <p v-if="index1 + 1 === data.item.course_id.length">{{
            item1.name
          }}</p>
          <p v-else>{{ item1.name }},</p>
        </div>
      </template>
      <template v-slot:cell(enterprise)="data">
        <p v-if="data.item.platform_id === 0">All</p>
        <p v-else>{{ data.item.config_info.site_name }}</p>
      </template>
      <template v-slot:cell(collegeId)="data">
        <ul>
          <li v-for="item in data.item.college" :key="item._id">
            {{ item.site_name }}
          </li>
        </ul>
      </template>
      <template v-slot:cell(categoryName)="data">
        <p v-if="data.item.category">{{ data.item.category.name }}</p>
      </template>
      <template v-slot:cell(subcategoryName)="data">
        <p v-if="data.item.subcategory">{{ data.item.subcategory.name }}</p>
      </template>
      <template v-slot:cell(report_status)="data">
        <b-badge
          v-if="data.item.status !== '' && data.item.status === 'pending'"
          variant="danger"
          >{{ data.item.status }}</b-badge
        >
        <b-badge
          v-if="data.item.status !== '' && data.item.status === 'done'"
          variant="success"
          >{{ data.item.status }}</b-badge
        >
      </template>

      <!--  Toggle detail view of table row  start  -->
      <template v-slot:cell(detailAction)="row">
        <b-button
          size="sm"
          class="mr-2"
          variant="link"
          @click="expandTable(row)"
          >{{ row.detailsShowing ? 'Hide' : 'Show' }} Details</b-button
        >
      </template>
      <template v-slot:row-details="row">
        <TableDetail :data="row" :table-name="tableName"></TableDetail>
      </template>
      <!--  Toggle detail view of table row end  -->

      <!-- A custom formatted header cell for item 'name' -->
      <template v-slot:cell(action)="data">
        <b-button-group>
          <b-button
            v-if="viewbtn"
            v-b-modal="'my-modal'"
            v-b-tooltip.hover
            title="View"
            variant="success"
            size="sm"
            @click="getdata(data.item)"
            ><i class="ti-eye icon-white"></i
          ></b-button>
          <b-button
            v-if="editbtn && role === ADMIN_ROLE"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-if="
              editbtn &&
                (role === COLLEGE_ROLE || role === TEACHER_ROLE) &&
                teacher
            "
            v-b-modal="'teacher-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getTeacherEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="
              editbtn &&
                (role === COLLEGE_ROLE || role === TEACHER_ROLE) &&
                assignment
            "
            v-b-modal="'assignment-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getAssignmentEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="
              editbtn &&
                (role === COLLEGE_ROLE || role === TEACHER_ROLE) &&
                resource
            "
            v-b-modal="'resource-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getResourceEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="editbtn && courseEvent"
            v-b-modal="'course-event-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getCourseEventEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="editbtn && liveclass"
            v-b-modal="'meeting-edit-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getMeetingEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="editbtn && editdomain"
            v-b-modal="'domain-edit-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getDomainEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="editbtn && trainingEvent"
            v-b-modal="'training-event-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getTrainingEventEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="editbtn && event"
            v-b-modal="'event-update-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getEventEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="editbtn && blog"
            v-b-modal="'blog-update-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getBlogEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-else-if="
              editbtn && (role === COLLEGE_ROLE || role === TEACHER_ROLE)
            "
            v-b-modal="'batch-modal'"
            v-b-tooltip.hover
            title="Edit"
            variant="primary"
            size="sm"
            @click="getBatchEdit(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && courseEvent"
            v-b-modal="'delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getCourseEventDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && trainingEvent"
            v-b-modal="'training-delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getTrainingEventDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && resource"
            v-b-modal="'resource-delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getResourceDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && assignment"
            v-b-modal="'assignment-delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getAssignmentDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="joinbtn"
            v-b-tooltip.hover
            title="Join Meeting"
            variant="warning"
            size="sm"
            @click="redirectMeeting(data.item)"
            ><i class="ti-share icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && liveclass"
            v-b-modal="'meeting-delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getMeetingDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && editdomain"
            v-b-modal="'domain-delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getDomainDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && event"
            v-b-modal="'event-delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getEventDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="deletebtn && blog"
            v-b-modal="'blog-delete-modal'"
            v-b-tooltip.hover
            title="Delete"
            variant="danger"
            size="sm"
            @click="getBlogDelete(data.item)"
            ><i class="ti-close icon-white"></i
          ></b-button>
          <b-button
            v-if="downloadbtn && role === ADMIN_ROLE"
            v-b-tooltip.hover
            title="Download"
            variant="default"
            size="sm"
            ><i class="ti-download icon-white"></i
          ></b-button>
          <b-button
            v-if="
              addbtn && role === ADMIN_ROLE && data.item.status === 'pending'
            "
            v-b-modal="'add-modal'"
            v-b-tooltip.hover
            title="Add"
            variant="primary"
            size="sm"
            @click="approvaldata(data.item)"
            ><i class="ti-pencil-alt icon-white"></i
          ></b-button>
        </b-button-group>
      </template>
      <template v-slot:cell(action1)="data">
        <b-button-group>
          <b-button
            v-if="
              uploadbtn && data.item.status === 'pending' && role === ADMIN_ROLE
            "
            v-b-modal="'upload-modal'"
            v-b-tooltip.hover
            title="Upload"
            variant="info"
            size="sm"
            @click="uploadReport(data.item)"
            ><i class="ti-upload icon-white"></i
          ></b-button>
          <b-button
            v-if="
              viewbtn &&
                data.item.type &&
                data.item.type !== 'custom' &&
                data.item.type !== 'requested'
            "
            v-b-tooltip.hover
            title="View"
            variant="success"
            size="sm"
            :to="'/report-list/' + data.item.type"
            ><i class="ti-eye icon-white"></i
          ></b-button>
          <DownloadButton
            v-if="downloadbtn && data.item.status !== 'pending'"
            v-b-tooltip.hover
            title="Download"
            :type="data.item.type"
            :downloadtype="'excel'"
            :item="data.item"
          >
          </DownloadButton>
        </b-button-group>
      </template>
    </b-table>

    <b-row align-h="between">
      <b-col v-if="items.length > 0" cols="4">
        <label>
          Showing {{ pagingCounter }} to
          {{ pagingCounter + (items.length - 1) }} of {{ totalRows }} entries
        </label>
      </b-col>
      <b-col v-else cols="4">
        <label>
          No entries found
        </label>
      </b-col>
      <b-col v-if="currentPage" cols="8">
        <b-pagination-nav
          class="pullRight"
          :link-gen="linkGen"
          :number-of-pages="totalPage"
          use-router
        ></b-pagination-nav>
      </b-col>
      <!-- <b-button v-if="downloadbtn" @click="pdf(all)">Download</b-button> -->
    </b-row>
    <Detail
      v-if="active"
      :data="details"
      :size="size"
      :display="displayFields"
    ></Detail>
    <Approval v-if="approveActive" :data="approvalDetails"></Approval>
    <Update v-if="update" :data="reportData"></Update>
    <Upload v-if="upload" :data="Report"></Upload>
    <BatchUpdate v-if="batchEdit" :data="batchData"></BatchUpdate>
    <AssignedUser v-if="showUsers" :data="usersData"></AssignedUser>
    <TeacherDataUpdate
      v-if="teacherEdit"
      :data="teacherData"
    ></TeacherDataUpdate>
    <AssignmentUpdate
      v-if="assignmentEdit"
      :data="assignmentData"
    ></AssignmentUpdate>
    <!-- <CourseEventUpdate
      v-if="courseEventEdit"
      :data="courseEventData"
    ></CourseEventUpdate>
    <CourseEventDelete
      v-if="deleteEvent"
      :data="deleteData"
    ></CourseEventDelete> -->
    <TrainingEventUpdate
      v-if="trainingEventEdit"
      :data="trainingEventData"
    ></TrainingEventUpdate>
    <TrainingEventDelete
      v-if="deleteTrainingEvent"
      :data="deleteTrainingData"
    ></TrainingEventDelete>
    <ResourceUpdate v-if="resourceEdit" :data="resourceData"></ResourceUpdate>
    <ResourceDelete
      v-if="deleteResource"
      :data="deleteResourceData"
    ></ResourceDelete>
    <AssignmentDelete
      v-if="deleteAssignment"
      :data="deleteAssignmentData"
    ></AssignmentDelete>
    <MeetingUpdate v-if="meetingEdit" :data="meetingEditData"></MeetingUpdate>
    <MeetingDelete
      v-if="meetingDelete"
      :data="meetingDeleteData"
    ></MeetingDelete>
    <DomainUpdate v-if="domainEdit" :data="domainEditData"></DomainUpdate>
    <DomainDelete v-if="domainDelete" :data="domainDeleteData"></DomainDelete>
    <EventUpdate v-if="eventUpdate" :data="eventUpdateData"></EventUpdate>
    <EventDelete v-if="eventDelete" :data="eventDeleteData"></EventDelete>
    <BlogUpdate v-if="blogUpdate" :data="blogUpdateData"></BlogUpdate>
    <BlogDelete v-if="blogDelete" :data="blogDeleteData"></BlogDelete>
  </div>
</template>
<style scoped>
.pullRight {
  float: right;
}
.capital {
  text-transform: uppercase;
}
#status {
  display: block !important;
}
.icon-white {
  color: white !important;
}
</style>
